import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto p-4 sm:p-6 lg:p-8">
        <header className="text-center mb-12 pt-12">
          <div className="mb-6">
            <i className="fas fa-landmark text-6xl text-primary mb-4"></i>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4 font-inter">
            Sistema de Gestão de Emendas Parlamentares
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Plataforma completa para gestão, alocação e visualização de emendas parlamentares com transparência e eficiência.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <Card className="border-2 hover:border-primary/50 transition-colors">
            <CardHeader>
              <CardTitle className="flex items-center">
                <i className="fas fa-chart-bar text-primary mr-3"></i>
                Relatório de Emendas
              </CardTitle>
              <CardDescription>
                Visualize relatórios detalhados das emendas dos vereadores organizados por categoria e vereador.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/relatorio">
                <Button className="w-full" size="lg">
                  <i className="fas fa-eye mr-2"></i>
                  Ver Relatório
                </Button>
              </Link>
            </CardContent>
          </Card>

          <Card className="border-2 hover:border-accent/50 transition-colors">
            <CardHeader>
              <CardTitle className="flex items-center">
                <i className="fas fa-cogs text-accent mr-3"></i>
                Admin do Sistema
              </CardTitle>
              <CardDescription>
                Gerencie vereadores, instituições e aloque recursos respeitando os limites estabelecidos.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/admin">
                <Button className="w-full" size="lg" variant="secondary">
                  <i className="fas fa-user-shield mr-2"></i>
                  Acessar Admin
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>

        <Card className="bg-muted/50">
          <CardHeader>
            <CardTitle className="flex items-center">
              <i className="fas fa-info-circle text-info mr-3"></i>
              Sobre o Sistema
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div>
                <i className="fas fa-shield-alt text-success text-2xl mb-3"></i>
                <h3 className="font-semibold mb-2">Transparência</h3>
                <p className="text-sm text-muted-foreground">
                  Acompanhe a destinação de recursos públicos com total transparência.
                </p>
              </div>
              <div>
                <i className="fas fa-users text-warning text-2xl mb-3"></i>
                <h3 className="font-semibold mb-2">Gestão Centralizada</h3>
                <p className="text-sm text-muted-foreground">
                  Gerencie múltiplos vereadores e instituições em um só lugar.
                </p>
              </div>
              <div>
                <i className="fas fa-chart-line text-diverse text-2xl mb-3"></i>
                <h3 className="font-semibold mb-2">Relatórios Detalhados</h3>
                <p className="text-sm text-muted-foreground">
                  Visualize dados organizados por categoria e período.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Index;
